import { registerDecorator, ValidationArguments, ValidationOptions } from 'class-validator';
import filter from 'lodash/filter';
import find from 'lodash/find';
import { store } from 'src/index';

export function IsStringPropertyUniqueInStoreSlice(property: string, validationOptions?: ValidationOptions) {
  return function (object: Object, propertyName: string) {
    registerDecorator({
      name: 'isStringPropertyAlreadyExists',
      target: object.constructor,
      propertyName: propertyName,
      constraints: [property],
      options: validationOptions,
      validator: {
        validate(currentPropertyValue: string = '', args: ValidationArguments) {
          const propertyValue = currentPropertyValue.trim().toLowerCase();
          const { property, object } = args;
          const reduxSlice = args.constraints[0];
          const storedValues = store.getState()[reduxSlice].values;

          const listWithoutCurrent = filter(storedValues, value => value.id !== (object as any).id);
          const isUnique = !find(
            listWithoutCurrent,
            storedValue => (storedValue[property] || '').trim().toLowerCase() === propertyValue
          );
          return isUnique;
        },
        defaultMessage(args: ValidationArguments) {
          const { value } = args;
          return `"${value}" is not unique, so please rename it.`;
        },
      },
    });
  };
}
